<template>
  <div class="center-warp">
    <div class="inner">
      <div class="count-card">
        <div class="count-card-top d-flex-between" style="align-items: center">
          <div class="count-card-top-title">客户数量</div>
          <div>
            <el-select
              v-model="form.group_id"
              placeholder=""
              size="small"
              disabled>
              <el-option
                v-for="item in options.memberGroupList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

            <el-select
              v-if="member.is_salesman_manager"
              v-model="form.salesman_ids"
              placeholder=""
              size="small"
              style="padding-left: 10px"
              clearable
              @change="handleSalesmanChange('client')">
              <el-option
                v-for="item in options.memberGroupUsers"
                :key="item.id"
                :label="item.real_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="count-card-bottom d-flex-between">
          <div class="count-card-item size4-1" @click="goPage('ctm',1)">
            <div class="count-card-item-name">客户总数</div>
            <div class="count-card-item-num">{{ client.count }}</div>
          </div>
          <div class="count-card-item size4-1" @click="goPage('data',1)">
            <div class="count-card-item-name">昨日新增</div>
            <div class="count-card-item-num">{{ client.yesterdayCount }}</div>
          </div>
          <div class="count-card-item size4-1" @click="goPage('data',1)">
            <div class="count-card-item-name">本月新增</div>
            <div class="count-card-item-num">{{ client.curMonthCount }}</div>
          </div>
          <div class="count-card-item size4-1" @click="goPage('data',4)">
            <div class="count-card-item-name">未办套餐病例</div>
            <div class="count-card-item-num">{{ client.noUnlockPatientCount }}</div>
          </div>
        </div>
      </div>
      <div class="count-card">
        <div class="count-card-top d-flex-between">
          <div class="count-card-top-title">客户回访</div>
          <div>
            <el-select
              v-model="form2.group_id"
              placeholder=""
              size="small"
              disabled>
              <el-option
                v-for="item in options.memberGroupList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select
              v-if="member.is_salesman_manager"
              v-model="form2.salesman_ids"
              placeholder=""
              size="small"
              style="padding-left: 10px"
              clearable
              @change="handleSalesmanChange('clientVisit')">
              <el-option
                v-for="item in options.memberGroupUsers"
                :key="item.id"
                :label="item.real_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="count-card-bottom d-flex-between">
          <div class="count-card-item size3-1" @click="goPage('data',2)">
            <div class="count-card-item-name">本月回访客户</div>
            <div class="count-card-item-num">{{ clientVisit.curMonthVisitCount }}</div>
          </div>
          <div class="count-card-item size3-1" @click="goPage('ctm',2)">
            <div class="count-card-item-name">本月待回访客户</div>
            <div class="count-card-item-num">{{ clientVisit.curMonthPendingVisitCount }}</div>
          </div>
          <div class="count-card-item size3-1" @click="goPage('data',3)">
            <div class="count-card-item-name">未建复诊卡病例</div>
            <div class="count-card-item-num">{{ clientVisit.noFzCardPatientCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getSalesmanData,getSalesmanClientData,getSalesmanClientVisitData} from "@/http/home";

export default {
  name: "SalesHome",
  data() {
    return {
      client: {},
      clientVisit: {},
      options: [],

      form: {},
      form2: {},

      member: {},
    };
  },
  created() {
    this.member = JSON.parse(localStorage.getItem('member'));
    this.getHomeData();
  },
  methods: {
    getHomeData() {
      getSalesmanData().then(res => {
        this.client = res.data.client
        this.clientVisit = res.data.clientVisit
        this.options = res.data.options

        let defaultGroupId = res.data.options.memberGroupList[0].id;

        this.form.group_id = defaultGroupId;
        this.form2.group_id = defaultGroupId;
      })
    },
    handleSalesmanChange(type) {
      if (type === 'client') {
        getSalesmanClientData(this.form).then(res => {
          this.client = res.data;
        });
      }
      if (type === 'clientVisit') {
        getSalesmanClientVisitData(this.form2).then(res => {
          this.clientVisit = res.data;
        });
      }
    },
    goPage(page,type){
      if(page == 'data'){
        this.$router.push({
          path:'/sales_data',
          query:{
            type:type
          }
        })
      }else{
        this.$router.push({
          path:'/sales_custom',
          query:{
            type:type
          }
        })
      }
    }
  },
}
</script>

<style scoped src="../../assets/css/sales_home.css">
</style>
